import { createRouter, createWebHistory } from "vue-router"
import { useUserStore } from '@/stores/userStore'

import store from "@/store"
import AppHome from "../views/Dashboard";
import AppHomeFreemium from "../views/DashboardFreemium";
import AppLogin from "../views/Login";
import AppRegister from "../views/Register";
import AppE404 from '../views/E404';
import AppCompanies from '../views/Home';
import AppCompany from '../views/Company';
import AppProject from '../views/ProjectOne';
import AppInvite from '../views/Invite';
import AppVerify from '../views/Verify';
import AppForgot from '../views/Forgot';
import AppSettings from '../views/Settings';
import AppMessages from '../views/Messages';
import AppTeam from '../views/Team';
import AppAdmin from '../views/Admin';

const routes = [
    {
        name: 'dashboard',
        path: '/',
        component: AppHome,
        meta: { auth: true, access: true, title: "NexPlan - Home" }
    },
    {
        name: 'dashboardFreemium',
        path: '/',
        component: AppHomeFreemium,
        meta: { auth: true, title: "NexPlan - Home" }
    },         
    {
        name: 'companies',
        path: '/companies',
        component: AppCompanies,
        meta: { auth: true, title: "NexPlan - Projects"  }
    },    
    {
        name: 'company',
        path: '/company/:id',
        component: AppCompany,
        meta: { auth: true, title: "NexPlan - Company"  }
    },
    {
        name: 'project',
        path: '/project/:id',
        component: AppProject,
        meta: { auth: true, title: "NexPlan - Project"  }
    },
    {
        name: 'messages',
        path: '/messages',
        component: AppMessages,
        meta: { auth: true, title: "NexPlan - Messages" }
    },      
    {
        name: 'team',
        path: '/team',
        component: AppTeam,
        meta: { auth: true, title: "NexPlan - Team" }
    },     
    {
        name: 'settings',
        path: '/settings',
        component: AppSettings,
        meta: { auth: true, title: "NexPlan - Settings" }
    }, 
    {
        name: 'admin',
        path: '/admin',
        component: AppAdmin,
        meta: { auth: true, title: "NexPlan - admin panel" }
    },    
    {
        name: 'login',
        path: '/login',
        component: AppLogin,
        meta: { title: "NexPlan - Login"  }
    },
    {
        name: 'register',
        path: '/register',
        component: AppRegister,
        meta: { title: "NexPlan - Register"  }
    },
    {
        name: 'invite',
        path: '/invite',
        component: AppInvite,
        meta: { title: "NexPlan - Invite"  },
        props: (route) => ({ code: route.query.code, from: route.query.from }) 
    },
    {
        name: 'verify',
        path: '/verify',
        component: AppVerify,
        meta: { title: "NexPlan - Verity"  },
        props: (route) => ({ code: route.query.key }) 
    },    
    {
        name: 'forgot',
        path: '/forgot',
        component: AppForgot,
        meta: { title: "NexPlan - Forgot password"  }
    },    
    {
        path: '/:any(.*)', // .*
        component: AppE404
    }
];

const router = createRouter({
    routes,
    history: createWebHistory()
});

router.beforeEach(async (to, from, next) => {
    const userStore = useUserStore()
    await userStore.autoLogin()

    const isLogin = userStore.isAuthenticated //localStorage.getItem('user')
    const isFreemium = userStore.isFreemium

    document.title = to.meta.title || 'NexPlan';

    if (to.meta.auth && !isLogin) {
        // console.log(isLogin)
        next({ name: 'login' })
    } else {
        if (to.name == 'login' && isLogin) {
            if (isFreemium)
                next({ name: 'dashboardFreemium' })
            else 
                next({ name: 'dashboard' })
        } else {
            if (to.name == 'dashboard') {
                if (isFreemium)
                    next({ name: 'dashboardFreemium' })
                else 
                    next({ name: 'dashboard' })                
            }
            next();
        }
    }
});

export default router;